import { useTranslation } from 'react-i18next';
import { useUserContextSelector } from '@/redux';
import { TabPanel } from '@/components';
import { TermsAndConditionsListPanel } from './TermsAndConditionsListPanel';
import { UpdateTermsAndConditionsButton } from './UpdateTermsAndConditionsButton';

export function TermsAndConditionsTabPanel() {
  const [hasRole] = useUserContextSelector((x) => [x.hasRole]);
  const canModify = hasRole('BFP_ADMIN');

  const { t } = useTranslation();

  return (
    <TabPanel min="auto">
      <TabPanel.Title>{t('termsAndConditions.title')}</TabPanel.Title>
      <TabPanel.Actions>
        {canModify && <UpdateTermsAndConditionsButton />}
      </TabPanel.Actions>
      <TabPanel.Body>
        <TermsAndConditionsListPanel />
      </TabPanel.Body>
    </TabPanel>
  );
}
